import React from "react";

// Import logo images
import logo1 from '../Assets/Images/HHG_Final_Logo.png';
import logo2 from '../Assets/Images/amvian.png';
import logo3 from '../Assets/Images/1864697.png';
import logo4 from '../Assets/Images/HITACHI.svg';
import logo5 from '../Assets/Images/RECARO.svg';
import logo6 from '../Assets/Images/THERMAX-2.svg';
import logo7 from '../Assets/Images/VOLVO-1.svg';

// Import background image
import bgImage from '../Assets/Images/white_paint_background.jpg';

const logos = [logo2, logo3, logo4, logo5, logo6, logo7];

export const FloatingBubbles = () => {
  return (
    <div className="relative w-full h-[600px] overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30 z-[-2]"
        style={{ backgroundImage: `url(${bgImage})` }}
      />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(251,251,251,0.15)_0%,_#8e9395_100%)] z-[-1]" />

      {/* Title */}
      <h2 className="text-[#060606] text-3xl md:text-4xl font-bold text-center pt-12 mb-2 z-10 relative">
        Trusted By
      </h2>

      {/* Subtitle */}
      <p className="text-[#333] text-center text-lg md:text-xl font-medium mb-6 z-10 relative" style={{color:'#787371'}}>
        Renowned brands from across industries
      </p>

      {/* Bubbles */}
      {logos.map((logo, index) => (
        <div
          key={index}
          className={`bubble bubble${index + 1} absolute w-60 h-60 rounded-full bg-white/40 backdrop-blur-lg flex items-center justify-center shadow-xl`}
        >
          <img
            src={logo}
            alt={`logo${index + 1}`}
            className="w-52 h-52 object-contain"
          />
        </div>
      ))}

      {/* Animations & Positioning */}
      <style>{`
        @keyframes float1 { 0% { transform: translateY(0); } 50% { transform: translateY(-20px); } 100% { transform: translateY(0); } }
        @keyframes float2 { 0% { transform: translateY(0); } 50% { transform: translateY(-30px); } 100% { transform: translateY(0); } }
        @keyframes float3 { 0% { transform: translateY(0); } 50% { transform: translateY(-25px); } 100% { transform: translateY(0); } }

        .bubble1 { top: 60px; left: 5%; animation: float1 6s ease-in-out infinite; }
        .bubble2 { top: 100px; left: 28%; animation: float2 7s ease-in-out infinite; }
        .bubble3 { top: 200px; left: 45%; animation: float1 5s ease-in-out infinite; }
        .bubble4 { top: 300px; left: 63%; animation: float3 6s ease-in-out infinite; }
        .bubble5 { top: 50px; left: 79%; animation: float2 5.5s ease-in-out infinite; }
        .bubble6 { top: 360px; left: 15%; animation: float3 7.5s ease-in-out infinite; }
        .bubble7 { top: 190px; left: 95%; animation: float1 6.5s ease-in-out infinite; }
      `}</style>
    </div>
  );
};
